/** Small styled form primitives shared by the admin entity dialogs. */
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';

export const inputCls = 'bg-slate-950/50 border-slate-700';

export function Field({ label, children }) {
        return (
                <div className="space-y-1.5">
                        <Label>{label}</Label>
                        {children}
                </div>
        );
}

export function TextField({ label, value, onChange, ...rest }) {
        return (
                <Field label={label}>
                        <Input value={value ?? ''} onChange={(e) => onChange(e.target.value)} className={inputCls} {...rest} />
                </Field>
        );
}

export function TextArea({ label, value, onChange, rows = 3 }) {
        return (
                <Field label={label}>
                        <textarea
                                value={value ?? ''}
                                onChange={(e) => onChange(e.target.value)}
                                rows={rows}
                                className="w-full rounded-md border border-slate-700 bg-slate-950/50 px-3 py-2 text-sm text-slate-100 focus:outline-none focus:ring-1 focus:ring-emerald-400/40"
                        />
                </Field>
        );
}

export function SelectField({ label, value, onChange, options, placeholder = '—', testId }) {
        return (
                <Field label={label}>
                        <select
                                value={value ?? ''}
                                onChange={(e) => onChange(e.target.value)}
                                data-testid={testId}
                                className="w-full rounded-md border border-slate-700 bg-slate-950/50 px-3 py-2 text-sm text-slate-100"
                        >
                                <option value="">{placeholder}</option>
                                {options.map((o) => (
                                        <option key={o.value} value={o.value}>{o.label}</option>
                                ))}
                        </select>
                </Field>
        );
}

// Event form times are always Italian time (Europe/Rome), stored as UTC.
export { utcToRomeInput as toLocalInput, romeInputToUtc as toISO } from '@/lib/romeTime';
